<template>
    <div class="balance-user">
        <video v-if="type == '1'" style="width: 100%;"
            src="https://hashintoken1.oss-accelerate.aliyuncs.com/intoken.mp4" autoplay loop></video>
        <video v-if="type == '2'" style="width: 100%;" src="https://hashtrust.oss-accelerate.aliyuncs.com/trust.mp4"
            autoplay loop></video>
        <video v-if="type == '4'" style="width: 100%;" src="https://hashownbit1.oss-accelerate.aliyuncs.com/ownbit.mp4"
            autoplay loop></video>
        <video v-if="type == '3'" style="width: 100%;"
            src="https://hashtronlink1.oss-accelerate.aliyuncs.com/tronlink.mp4" autoplay loop></video>
        <video v-if="type == '5'" style="width: 100%;" src="https://hashbitpie1.oss-accelerate.aliyuncs.com/bitpie.mp4"
            autoplay loop></video>
        <div v-if="language == 'Chinese'">
            <img v-if="type == '1'" src="../assets/1-1.png" style="width: 100%;" alt="">
            <img v-if="type == '2'" src="../assets/1-2.png" style="width: 100%;" alt="">
            <img v-if="type == '3'" src="../assets/1-3.png" style="width: 100%;" alt="">
            <img v-if="type == '4'" src="../assets/1-4.png" style="width: 100%;" alt="">
            <img v-if="type == '5'" src="../assets/1-5.png" style="width: 100%;" alt="">
        </div>
        <div v-if="language == 'English'">
            <img v-if="type == '1'" src="../assets/2-1.png" style="width: 100%;" alt="">
            <img v-if="type == '2'" src="../assets/2-2.png" style="width: 100%;" alt="">
            <img v-if="type == '3'" src="../assets/2-3.png" style="width: 100%;" alt="">
            <img v-if="type == '4'" src="../assets/2-4.png" style="width: 100%;" alt="">
            <img v-if="type == '5'" src="../assets/2-5.png" style="width: 100%;" alt="">
        </div>
        <div v-if="language == 'Traditional'">
            <img v-if="type == '1'" src="../assets/3-1.png" style="width: 100%;" alt="">
            <img v-if="type == '2'" src="../assets/3-2.png" style="width: 100%;" alt="">
            <img v-if="type == '3'" src="../assets/3-3.png" style="width: 100%;" alt="">
            <img v-if="type == '4'" src="../assets/3-4.png" style="width: 100%;" alt="">
            <img v-if="type == '5'" src="../assets/3-5.png" style="width: 100%;" alt="">
        </div>
        <div v-if="language == 'Japanese'">
            <img v-if="type == '1'" src="../assets/4-1.png" style="width: 100%;" alt="">
            <img v-if="type == '2'" src="../assets/4-2.png" style="width: 100%;" alt="">
            <img v-if="type == '3'" src="../assets/4-3.png" style="width: 100%;" alt="">
            <img v-if="type == '4'" src="../assets/4-4.png" style="width: 100%;" alt="">
            <img v-if="type == '5'" src="../assets/4-5.png" style="width: 100%;" alt="">
        </div>
        <div v-if="language == 'Vietnamese'">
            <img v-if="type == '1'" src="../assets/5-1.png" style="width: 100%;" alt="">
            <img v-if="type == '2'" src="../assets/5-2.png" style="width: 100%;" alt="">
            <img v-if="type == '3'" src="../assets/5-3.png" style="width: 100%;" alt="">
            <img v-if="type == '4'" src="../assets/5-4.png" style="width: 100%;" alt="">
            <img v-if="type == '5'" src="../assets/5-5.png" style="width: 100%;" alt="">
        </div>
        <div v-if="language == 'Malay'">
            <img v-if="type == '1'" src="../assets/6-1.png" style="width: 100%;" alt="">
            <img v-if="type == '2'" src="../assets/6-2.png" style="width: 100%;" alt="">
            <img v-if="type == '3'" src="../assets/6-3.png" style="width: 100%;" alt="">
            <img v-if="type == '4'" src="../assets/6-4.png" style="width: 100%;" alt="">
            <img v-if="type == '5'" src="../assets/6-5.png" style="width: 100%;" alt="">
        </div>
        <div v-if="language == 'Hindi'">
            <img v-if="type == '1'" src="../assets/7-1.png" style="width: 100%;" alt="">
            <img v-if="type == '2'" src="../assets/7-2.png" style="width: 100%;" alt="">
            <img v-if="type == '3'" src="../assets/7-3.png" style="width: 100%;" alt="">
            <img v-if="type == '4'" src="../assets/7-4.png" style="width: 100%;" alt="">
            <img v-if="type == '5'" src="../assets/7-5.png" style="width: 100%;" alt="">
        </div>
        <div v-if="language == 'Thai'">
            <img v-if="type == '1'" src="../assets/8-1.png" style="width: 100%;" alt="">
            <img v-if="type == '2'" src="../assets/8-2.png" style="width: 100%;" alt="">
            <img v-if="type == '3'" src="../assets/8-3.png" style="width: 100%;" alt="">
            <img v-if="type == '4'" src="../assets/8-4.png" style="width: 100%;" alt="">
            <img v-if="type == '5'" src="../assets/8-5.png" style="width: 100%;" alt="">
        </div>
        <div v-if="language == 'Russian'">
            <img v-if="type == '1'" src="../assets/9-1.png" style="width: 100%;" alt="">
            <img v-if="type == '2'" src="../assets/9-2.png" style="width: 100%;" alt="">
            <img v-if="type == '3'" src="../assets/9-3.png" style="width: 100%;" alt="">
            <img v-if="type == '4'" src="../assets/9-4.png" style="width: 100%;" alt="">
            <img v-if="type == '5'" src="../assets/9-5.png" style="width: 100%;" alt="">
        </div>
        <div v-if="language == 'Indonesian'">
            <img v-if="type == '1'" src="../assets/10-1.png" style="width: 100%;" alt="">
            <img v-if="type == '2'" src="../assets/10-2.png" style="width: 100%;" alt="">
            <img v-if="type == '3'" src="../assets/10-3.png" style="width: 100%;" alt="">
            <img v-if="type == '4'" src="../assets/10-4.png" style="width: 100%;" alt="">
            <img v-if="type == '5'" src="../assets/10-5.png" style="width: 100%;" alt="">
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            type: '',
            language: ''
        };
    },
    created() {
        this.type = this.$route.query.type
        this.language = localStorage.getItem('language') || 'Chinese'
    },
    mounted() {

    },
    methods: {
        toBack() {
            this.$router.push("/user");
        },
    },
};
</script>

<style lang="scss" scoped>
.balance-user {
    width: 100vw;
}
</style>


// WEBPACK FOOTER //
// src/help/guide.vue